/**
 * Secciones del menú. Calcan las secciones del AF (y, por lo tanto, los `modules/` del
 * backend): cada pantalla del mapa de §2 cae en la sección que la especifica.
 */
import type { LucideIcon } from "lucide-react";
import {
  Banknote,
  BookUser,
  CalendarRange,
  ChartNoAxesColumn,
  DoorOpen,
  FileSpreadsheet,
  GraduationCap,
  MessagesSquare,
  Rocket,
  Settings2,
  ShieldCheck,
  Tag,
  UserRound,
  Users,
} from "lucide-react";

export type SectionId =
  | "inicio"
  | "socios"
  | "planes"
  | "clases"
  | "acceso"
  | "profesores"
  | "caja"
  | "contable"
  | "crm"
  | "roles"
  | "reportes"
  | "migracion"
  | "config"
  | "capacitacion"
  | "cuenta";

export interface SectionDef {
  id: SectionId;
  label: string;
  /** Sección del AF que la especifica (`§3`, `§11`…). `—` si es transversal. */
  spec: string;
  icon: LucideIcon;
  order: number;
}

export const SECTIONS: Record<SectionId, SectionDef> = {
  inicio: { id: "inicio", label: "Inicio", spec: "§12", icon: ChartNoAxesColumn, order: 0 },
  socios: { id: "socios", label: "Socios", spec: "§3", icon: Users, order: 1 },
  planes: { id: "planes", label: "Planes y cobranzas", spec: "§4", icon: Tag, order: 2 },
  clases: { id: "clases", label: "Clases y grilla", spec: "§5", icon: CalendarRange, order: 3 },
  acceso: { id: "acceso", label: "Acceso", spec: "§6", icon: DoorOpen, order: 4 },
  profesores: { id: "profesores", label: "Personal", spec: "§7", icon: BookUser, order: 5 },
  caja: { id: "caja", label: "Caja", spec: "§8", icon: Banknote, order: 6 },
  contable: {
    id: "contable",
    label: "Contable y kiosko",
    spec: "§9",
    icon: FileSpreadsheet,
    order: 7,
  },
  crm: { id: "crm", label: "CRM y comunicación", spec: "§10", icon: MessagesSquare, order: 8 },
  reportes: { id: "reportes", label: "Reportes", spec: "§12", icon: ChartNoAxesColumn, order: 9 },
  roles: { id: "roles", label: "Usuarios y auditoría", spec: "§11", icon: ShieldCheck, order: 10 },
  config: { id: "config", label: "Configuración", spec: "§11 / §1.4", icon: Settings2, order: 11 },
  migracion: { id: "migracion", label: "Puesta en marcha", spec: "§13", icon: Rocket, order: 12 },
  // No es una sección del AF: el curso de uso del sistema (`docs/spec/capacitacion.md`,
  // herramienta de la capacitación por rol de AF §13.5).
  capacitacion: {
    id: "capacitacion",
    label: "Capacitación",
    spec: "§13.5",
    icon: GraduationCap,
    order: 13,
  },
  cuenta: { id: "cuenta", label: "Mi cuenta", spec: "—", icon: UserRound, order: 14 },
};

export const SECTION_ORDER: SectionId[] = Object.values(SECTIONS)
  .sort((a, b) => a.order - b.order)
  .map((section) => section.id);
